export const menuDetailFeatureTranslationJP = {
  menuDetailFeature: {
    Component: {
      csv_output: 'csv output',
      delete: 'delete',
      close: '閉じる',
      setting: 'setting',
      search: 'search',
      reload: 'reload',
      detail: 'detail',
      save_btn: '保存',
      change_btn: '変更',
    },
    Text: {
      menu_detail_normal: 'メニュー詳細',
      menu_detail_sub: 'メニュー詳細',
      all: '全て',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      traditional_chinese: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      display_name: '表示名',
      remarks: '備考',
      menu_settings: '〇メニュー設定',
      notice_text:
        '※モバイルオーダーの表示名、説明は、 <br />　日本語以外の言語を選択し、その言語が未設定の場合、 <br />　英語が表示されます。 <br />',
      register_information: '〇レジ情報',
      menu_name: 'メニュー名',
      menu_type: ' メニュー種別',
      display_timing: '表示タイミング',
      menu_property: 'プロパティ',
      menu_image: '画像',
      explanation: '説明',
      note1: '注釈１',
      note2: '注釈2',
      note3:
        '※制御条件が、表示制御グループのみ選択可能です<br />※表示制御グループは複数選択可能ですが、すべてのグループがオーダーされたときのみアクティブになります。',
      overlay_group: '任意オーバーレイ表示',
      default_overlay_group: '設定無し',
      order_limit_type: 'コース注文数制限',
      default_order_limit: '設定無し',
      note4:
        'こちらを設定した場合、コース詳細で注文数<br/>制限が有効になったコース対して、<br/>注文数の制限を行います。',
      control_condition: '制御条件',
      display_control_group: '表示制御　<br/>グループ：',
      sub_menu_settings: '〇サブメニュー設定',
      sub_menu_property: 'サブメニュー属性',
      provide_content: '提供内容：',
      limit_and_option: '制限・オプション：',
      limit_and_option_enabled: '提供タイミング： 有効（レジデータ取込から取得）',
      limit_and_option_disabled: '提供タイミング： 無効（レジデータ取込から取得）',
      wizard_title: 'ウィザード : ',
      invalid: '無効',
      promotional_image: 'プロモーション<br/>画像',
      hide_option: '非表示',
    },
    Table: {
      date_of_expired: '有効期限',
      start: '開始',
      end: '終了',
      pos_cd: 'POSコード',
      pos_name: 'POS名',
      amount_of_money_excluding_tax: '金額<br/>(税抜き)',
      amount_of_money_including_tax: '金額<br />（税込み） <br />※レジデータ取 <br />込から取得',
      normal: '通常',
      sub: 'サブ',
      normal_price_including_tax: '通常金額<br/>(税込み)',
      sub_price_including_tax: 'サブ金額<br/>(税込み)',
    },
    Form: {
      title_success: '成功',
      save_success: '保存しました',
      required: '必須フィールド',
    },
  },
};
